export default __webpack_public_path__ + "static/media/title2.c5953759.svg";